<template>
  <div>
    <div
      style="display: flex; justify-content: flex-start; align-items: center"
    >
      <a-button style="margin-right: 5px" type="primary" @click="fetch()"
        >刷新列表
        <a-icon type="retweet" />
      </a-button>
      <!--<a-button style="margin-right: 5px" type="primary" @click="fetch(1)">获取全量信息-->
      <!--<a-icon type="retweet"/>-->
      <!--</a-button>-->
      <a-button style="margin-right: 5px" type="primary" @click="newBot"
        >添加机器人
        <a-icon type="plus" />
        <newBotModal
          :visible="newBotVisible"
          v-on:on-finish="newBotFinish"
          v-on:on-cancel="newBotCancel"
        ></newBotModal>
      </a-button>
      <a-button style="margin-right: 5px" type="primary" @click="botStatisList"
        >机器人列表导出</a-button
      >
      <a-button
        v-if="this.showUnhealthBot"
        style="margin-right: 5px"
        type="primary"
        @click="showUnhealthBotFunc(false)"
        >隐藏异常机器人</a-button
      >
      <a-button
        v-else
        style="margin-right: 5px"
        type="primary"
        @click="showUnhealthBotFunc(true)"
        >显示全部机器人</a-button
      >
      <span style="margin-left: auto" v-if="this.available != null">
        {{ "当前可用群数：" + this.available }}
      </span>
    </div>
    <div style="margin-top: 10px">
      <label title="用户昵称" class="info">昵称</label
      ><a-input
        style="max-width: 10%; margin-right: 20px"
        placeholder="支持模糊匹配"
        v-model="searchNickname"
        @pressEnter="search"
      />
      <label title="微信号" class="info">微信号</label
      ><a-input
        style="max-width: 10%; margin-right: 20px"
        placeholder="仅支持全匹配"
        v-model="searchUsername"
        @pressEnter="search"
      />
      <label title="手机号" class="info">alias</label
      ><a-input
        style="max-width: 10%; margin-right: 20px"
        placeholder="仅支持全匹配"
        v-model="searchAlias"
        @pressEnter="search"
      />
      <a-button type="primary" @click="search">搜索</a-button>
      <a-button type="primary" @click="clear">清空</a-button>
    </div>
    <a-table
      :columns="columns"
      :dataSource="dataCurrent"
      :loading="loading"
      :pagination="pagination"
      @change="handleTableChange"
      class="bot-table"
      style="font-size: 12px !important; margin-top: 10px"
    >
      <!-- 机器人 -->
      <div class="avatar-36-con" slot="base_info" slot-scope="text">
        <img class="avatar" :src="text.avatar_url" />
        <div class="nickname">
          {{ text.nickname + "（" + text.username + "）" }}
        </div>
      </div>
      <!--<div slot="is_alive" slot-scope="text">-->
      <!--<span v-if="text"> {{ '活' }} </span>-->
      <!--<span v-if="!text" style="color: #ff4d4f"> {{ '挂' }} </span>-->
      <!--</div>-->
      <template slot="enter_chatroom_count" slot-scope="text, record">
        <div class="editable-cell">
          <div v-if="chosedBot === record" class="editable-cell-input-wrapper">
            <a-input
              v-model="enter_chatroom_count"
              ref="input"
              @pressEnter="checkChatroomCount(record, 'all')"
              style="width: 70%; margin-right: 10px"
            ></a-input>
            <a-icon
              type="check"
              class="editable-cell-icon-check"
              style="cursor: pointer"
              @click="checkChatroomCount(record, 'all')"
            ></a-icon>
          </div>
          <div v-else>
            <span v-show="record.enter_chatroom_count">{{
              record.enter_chatroom_count
            }}</span>
            <a-icon
              type="edit"
              class="editable-cell-icon"
              style="cursor: pointer"
              @click="editChatroomCount(record, 'all')"
            ></a-icon>
          </div>
        </div>
      </template>

      <template slot="daily_enter_chatroom_count" slot-scope="text, record">
        <div class="editable-cell">
          <div
            v-if="chosedBotDaily === record"
            class="editable-cell-input-wrapper"
          >
            <a-input
              v-model="daily_enter_chatroom_count"
              ref="input"
              @pressEnter="checkChatroomCount(record, 'daily')"
              style="width: 70%; margin-right: 10px"
            ></a-input>
            <a-icon
              type="check"
              class="editable-cell-icon-check"
              style="cursor: pointer"
              @click="checkChatroomCount(record, 'daily')"
            ></a-icon>
          </div>
          <div v-else>
            <span v-show="record.daily_enter_chatroom_count">{{
              record.daily_enter_chatroom_count
            }}</span>
            <a-icon
              type="edit"
              class="editable-cell-icon"
              style="cursor: pointer"
              @click="editChatroomCount(record, 'daily')"
            ></a-icon>
          </div>
        </div>
      </template>

      <div slot="blocked" slot-scope="text, record">
        <span v-if="text == 1 && record.is_alive" style="color: green"
          >正在服务</span
        >
        <span v-if="text == 1 && !record.is_alive" style="color: red"
          >服务异常</span
        >
        <span v-if="text == 2" style="color: orange">等待解封</span>
        <span v-if="text == 3" style="color: grey">彻底损失</span>
      </div>
      <!--<div slot="destroyed_remark" slot-scope="text">-->
      <!--{{text}}-->
      <!--</div>stroyed_remark" slot-scope="text">-->
      <!--{{text}}-->
      <!--</div>-->
      <div slot="role" slot-scope="text, record">
        <a-select v-model="text" @select="onRoleSelected($event, record)">
          <a-select-option value="0"> C 端</a-select-option>
          <a-select-option value="1"> 小 B</a-select-option>
          <a-select-option value="2"> 专属</a-select-option>
          <a-select-option value="3"> 未知</a-select-option>
        </a-select>
      </div>
      <div slot="biz_id" slot-scope="text, record">
        <a-select
          @select="bindBiz($event, record)"
          v-model="record.u_biz_id"
          style="width: 100px"
        >
          <a-select-option v-for="biz in biz_list" :value="biz.u_biz_id">
            {{ biz.biz_name }}
          </a-select-option>
        </a-select>
      </div>
      <div slot="origin" slot-scope="text, record">
        <a-select v-model="text" @select="onBelongingSelected($event, record)">
          <a-select-option value="采购"> 采购 </a-select-option>
          <a-select-option value="客供"> 客供 </a-select-option>
        </a-select>
      </div>
      <!--<div slot="chatroom_count" slot-scope="text">-->
      <!--{{ (text !== undefined && text.today !== undefined) ? text.today + '/' + text.total : '-/-'}}-->
      <!--</div>-->
      <div slot="register_pwd" slot-scope="text, record">
        <div class="editable-cell">
          <div
            v-if="choosedLoginPwdEdit === record.a_contact_id"
            class="editable-cell-input-wrapper"
          >
            <a-input
              v-model="register_pwd_text"
              ref="input"
              @pressEnter="checkLoginPwd(record)"
              style="width: 70%; margin-right: 10px"
            ></a-input>
            <a-icon
              type="check"
              class="editable-cell-icon-check"
              @click="checkLoginPwd(record)"
            ></a-icon>
          </div>
          <div v-else>
            {{ text }}
            <a-icon
              type="edit"
              class="editable-cell-icon"
              v-bind:key="record.a_contact_id"
              @click="editLoginPwd(record)"
            />
          </div>
        </div>
      </div>
      <div slot="pay_pwd" slot-scope="text, record">
        <div class="editable-cell">
          <div
            v-if="choosedPayPwdEdit === record.a_contact_id"
            class="editable-cell-input-wrapper"
          >
            <a-input
              v-model="pay_pwd_text"
              ref="input"
              @pressEnter="checkPayPwd(record)"
              style="width: 70%; margin-right: 10px"
            ></a-input>
            <a-icon
              type="check"
              class="editable-cell-icon-check"
              @click="checkPayPwd(record)"
            ></a-icon>
          </div>
          <div v-else>
            {{ text
            }}<a-icon
              type="edit"
              class="editable-cell-icon"
              v-bind:key="record.a_contact_id"
              @click="editPayPwd(record)"
            />
          </div>
        </div>
      </div>
      <div slot="actions" slot-scope="text, record">
        <a-dropdown>
          <a-menu slot="overlay" @click="handleMenuClick($event, record)">
            <!--<a-menu-item v-if="record.vip !== 2" key='start_keep_alive'>开始养号</a-menu-item>-->
            <!--<a-menu-item v-if="record.vip === 2" key='stop_keep_alive'>停止养号</a-menu-item>-->
            <!--<a-menu-item v-if="!record.blocked || record.blocked === 0" key='mark_as_blocked'>标记封号</a-menu-item>-->
            <!--<a-menu-item v-if="record.blocked === 1" key='mark_as_unblocked'>解除封号</a-menu-item>-->
            <a-menu-item key="detail">查看详情</a-menu-item>
            <a-menu-item key="remark">填写备注</a-menu-item>
            <a-menu-item key="bind_client">预绑定客户</a-menu-item>
            <a-menu-item key="bind_chatroom">群关系绑定</a-menu-item>
            <a-menu-item
              v-if="!batchQuitChatroomLoading && !batchQuitChatroomFlag"
              key="batch_quit_chatroom"
              >一键退群
            </a-menu-item>
            <a-menu-item
              v-if="!batchQuitChatroomLoading && batchQuitChatroomFlag"
              key="batch_quit_chatroom_confirm"
            >
              一键退群确认
            </a-menu-item>
            <a-menu-item
              v-if="!keepAliveLoading && !record.keep_alive"
              key="add_keep_alive_bot"
              >开始养号</a-menu-item
            >
            <a-menu-item
              v-if="!keepAliveLoading && record.keep_alive"
              key="remove_keep_alive_bot"
              >停止养号</a-menu-item
            >
            <a-menu-item key="destroy_reason">标记损失</a-menu-item>
            <a-menu-item key="bot_abnormal_log">查看异常行为</a-menu-item>
            <a-menu-item key="bot_friends">好友列表</a-menu-item>
            <a-menu-item key="get_bot_friends">导出好友列表</a-menu-item>
            <a-menu-item key="groupSending">私聊群发</a-menu-item>
            <a-menu-item key="blocked_reason">封号原因</a-menu-item>
            <a-menu-item key="unblocked_record">解封记录</a-menu-item>
            <a-menu-item
              v-if="!underCheckingLoading && !record.under_checking"
              key="under_checking"
              >开始监控该设备</a-menu-item
            >
            <a-menu-item
              v-if="!underCheckingLoading && record.under_checking"
              key="stop_under_checking"
              >停止监控该设备</a-menu-item
            >
            <a-menu-item key="hand_off">新设备登录验证</a-menu-item>
          </a-menu>
          <a-button>
            操作
            <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </div>
    </a-table>
    <BindClientModal
      :data="bindClientModalData"
      :visible="bindClientVisible"
      :confirmLoading="bindClientConfirmLoading"
      v-on:on-finish="bindClientFinish"
      v-on:on-cancel="bindClientCancel"
    ></BindClientModal>
    <BindChatroomModal
      :data="bindChatroomModalData"
      :visible="bindChatroomVisible"
      :chatroomnameSelected="[]"
      :confirmLoading="bindClientConfirmLoading"
      v-on:on-finish="bindChatroomFinish"
      v-on:on-cancel="bindChatroomCancel"
    ></BindChatroomModal>
    <!-- 标记损失 -->
    <template>
      <div>
        <a-modal
          title="标记损失"
          :visible="visible_lose"
          @ok="handleLoseOk"
          :confirmLoading="confirmLoading_abnormal"
          @cancel="handleLoseCancel"
        >
          <div style="display: flex; flex-direction: column">
            <a-radio-group v-model="robot_status_value">
              当前状态设置：
              <a-radio :value="1">正在服务</a-radio>
              <a-radio :value="2">等待解封</a-radio>
              <a-radio :value="3">彻底损失</a-radio>
            </a-radio-group>
            <span
              style="margin-top: 10px; display: flex; flex-direction: column"
            >
              损失原因:<a-input
                v-model="lose_reason"
                placeholder="填写损失原因"
              />
              <br />
              解封手机号:<a-input
                v-model="block_phone_number"
                placeholder="填写解封手机号"
              />
            </span>
          </div>
        </a-modal>
      </div>

      <!-- 机器人的人生路 -->
      <template>
        <div>
          <a-modal
            title="人生路"
            v-model="visible_abnormal"
            :confirmLoading="confirmLoading_abnormal"
            @ok="handleLogOK"
            :footer="null"
          >
            <div style="display: flex; flex-direction: column; width: 500px">
              <a-radio-group @change="showAbnormalLog" v-model="abnormal_type">
                选择状态查看：
                <a-radio :value="1">发言频繁</a-radio>
                <a-radio :value="2">进群过快</a-radio>
                <a-radio :value="3">加好友过快</a-radio>
                <a-radio :value="4">微信登出</a-radio>
              </a-radio-group>
              <div v-for="log in log_list">
                {{ log.bot_username }}{{ log.create_time }}
                <span v-if="log.type == 1"></span>
                <span v-if="log.type == 2"></span>
                <span v-if="log.type == 3"></span>
                <span v-if="log.type == 4"></span>
              </div>
            </div>
            <template>
              <a-pagination
                v-model="abnormalPage.page"
                :total="log_list.length || 0"
                :change="showAbnormalLog"
              ></a-pagination>
            </template>
          </a-modal>
        </div>
      </template>

      <!-- 机器人详情 -->
      <template>
        <div>
          <a-modal
            title="详情列表"
            v-model="visible_detail"
            :closable="false"
            @ok="handleDetailOK"
            :footer="null"
          >
            <!--<div>客户：-->
            <!--<a-select @select="bindBiz($event, detailData)" v-model="detailData.u_biz_id"  style="width: 200px; ">-->
            <!--<a-select-option v-for="biz in biz_list" :value="biz.u_biz_id"> {{biz.biz_name}} </a-select-option>-->
            <!--</a-select>-->
            <!--</div>-->
            <div>位置：{{ c_device ? c_device.location : "" }}</div>
            <div>
              物联网卡供应商：
              <a-select
                @select="bindProvider($event, detailData, 'iot_provider')"
                v-model="detailData.iot_provider"
                style="width: 200px; margin-bottom: 5px"
              >
                <a-select-option
                  v-for="provider in provider_list"
                  :value="provider.u_provider_id"
                >
                  {{ provider.provider_name }}
                </a-select-option>
              </a-select>
            </div>
            <div>
              号源：
              <a-select
                @select="bindProvider($event, detailData, 'wechat_provider')"
                v-model="detailData.wechat_provider"
                style="width: 200px; margin-bottom: 5px"
              >
                <a-select-option
                  v-for="provider in provider_list"
                  :value="provider.u_provider_id"
                >
                  {{ provider.provider_name }}
                </a-select-option>
              </a-select>
            </div>
            <div>
              4G 卡源：
              <a-select
                @select="bindProvider($event, detailData, 'four_g_provider')"
                v-model="detailData.four_g_provider"
                style="width: 200px; margin-bottom: 5px"
              >
                <a-select-option
                  v-for="provider in provider_list"
                  :value="provider.u_provider_id"
                >
                  {{ provider.provider_name }}
                </a-select-option>
              </a-select>
            </div>
            <div>创建时间：{{ detailData.create_time }}</div>
            <div>备注：{{ detailData.remark }}</div>
            <!--<div v-for="log in detailData.unlock_info_list">-->
            <!--<div>解封操作人：{{ log.username }}</div>-->
            <!--<div>辅助者手机号：{{ log.help_phone }}</div>-->
            <!--<div>操作时间：{{ transform(log.create_time, 'yyyy-MM-dd hh:mm:ss') }}</div>-->
            <!--</div>-->
            <div>损失原因：{{ detailData.destroyed_remark }}</div>
            <img
              :src="
                'https://ddywbdthumb.oss-cn-beijing.aliyuncs.com/' +
                detailData.username +
                '.jpg?x-oss-process=style/cover_img'
              "
            />
          </a-modal>
        </div>
      </template>

      <!-- 封号原因 -->
      <template>
        <div>
          <a-modal
            :title="'封号原因: ' + detailData.nickname"
            v-model="visible_block_reason"
            :closable="false"
            :footer="null"
          >
            <div style="display: inline-block; margin-bottom: 20px">
              <label title="新增封号原因" class="info">新增封号原因</label>
              <a-select v-model="blocked_reason" style="width: 200px">
                <a-select-option value="环境异常"> 环境异常 </a-select-option>
                <a-select-option value="使用外挂"> 使用外挂 </a-select-option>
                <a-select-option value="行为异常"> 行为异常 </a-select-option>
                <a-select-option value="未知"> 未知 </a-select-option>
              </a-select>
              <!--<a-input style="max-width: 100px; margin-right: 20px" placeholder="封号原因" v-model="blocked_reason"/>-->
              <a-button
                type="primary"
                @click="newBlockReason(detailData, blocked_reason)"
                >新增</a-button
              >
            </div>
            <div v-if="blocked_reason_loading">正在获取历史封号记录...</div>
            <div v-else>
              <div v-if="blocked_reason_list.length === 0">暂无</div>
              <div v-else>
                <div v-for="blocked_reason in blocked_reason_list">
                  <span>
                    {{
                      "时间: " +
                      $utils.getTimeByUnix(blocked_reason.create_time * 1000)
                    }}
                  </span>
                  <span> {{ "操作人: " + blocked_reason.username }} </span>
                  <span> {{ "原因: " + blocked_reason.blocked_reason }} </span>
                </div>
              </div>
            </div>
          </a-modal>
        </div>
      </template>

      <!-- 解封记录 -->
      <template>
        <div>
          <a-modal
            :title="'解封记录: ' + detailData.nickname"
            v-model="visible_unblocked_record"
            :closable="false"
            :footer="null"
          >
            <div style="display: inline-block; margin-bottom: 20px">
              <label title="新增解封记录" class="info">新增解封记录</label>
              <a-input
                style="max-width: 150px; margin-right: 20px"
                placeholder="协助者手机号"
                v-model="unblocked_phone"
              />
              <a-button
                type="primary"
                @click="newUnblockRecord(detailData, unblocked_phone)"
                >新增</a-button
              >
            </div>
            <div v-if="blocked_reason_loading">正在获取历史解封记录...</div>
            <div v-else>
              <div v-if="unblocked_record_list.length === 0">暂无</div>
              <div v-else>
                <div v-for="unblocked_record in unblocked_record_list">
                  <span>
                    {{
                      "时间: " +
                      $utils.getTimeByUnix(unblocked_record.create_time * 1000)
                    }}
                  </span>
                  <span> {{ "操作人: " + unblocked_record.username }} </span>
                  <span>
                    {{ "协助手机号: " + unblocked_record.help_phone }}
                  </span>
                </div>
              </div>
            </div>
          </a-modal>
        </div>
      </template>

      <!-- 添加备注 -->
      <template>
        <div>
          <a-modal
            title="备注"
            v-model="visible_remark"
            :closable="false"
            @ok="handleRemarkOK"
            @cancle="handleRemarkCancle"
          >
            <a-textarea
              placeholder="输入备注内容"
              v-model="remark"
              :autosize="{ minRows: 2, maxRows: 6 }"
            />
          </a-modal>
        </div>
      </template>

      <!-- 好友列表 -->
      <template>
        <div>
          <a-modal
            title="好友列表"
            v-model="visible_friends"
            :closable="false"
            @cancle="handleFriendsCancle"
          >
            <div>
              <a-input
                v-model="friendListFilter"
                @keydown.enter="getFilterList"
              ></a-input>
              <div
                v-for="friend in botShowFriendsList"
                style="display: flex; align-items: center; margin-top: 10px"
              >
                <img
                  :src="friend.avatar_url"
                  style="width: 46px; height: 46px; margin-right: 10px"
                />
                {{ friend.nickname }}
              </div>
              <!--<a-pagination size="small" :total="botFriendsList.length || 0"/>-->
            </div>
          </a-modal>
        </div>
      </template>

      <!-- 新设备登录 -->
      <template>
        <div>
          <a-modal
            title="二维码url"
            v-model="visible_hand_off"
            :closable="false"
            @ok="handOffOK"
          >
            <a-input v-model="handOffUrl"></a-input>
          </a-modal>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import BindClientModal from "./BindClientModal";
import BindChatroomModal from "./BindChatroomModal";
import newBotModal from "./newBotModal";

const axios = require("axios");
export default {
  name: "BotManage",
  components: { BindClientModal, newBotModal, BindChatroomModal },
  data() {
    return {
      getBotListUrlPostFix: "UBot/get_bot_list",
      bindClientUrlPostFix: "UBot/bind_client",
      getBlockedReasonListUrlPostFix: "UBot/get_blocked_reason_list",
      getUnblockedRecordListUrlPostFix: "UBot/get_unblocked_record_list",
      newBlockedReasonUrlPostFix: "UBot/new_blocked_reason",
      newUnblockedRecordUrlPostFix: "UBot/new_unblocked_record",
      batchBindChatroomUrlPostFix: "UChatroom/batch_bind_chatroom",
      EditBotTypeUrlPostFix: "UBot/edit_bot_type",
      EditBelongingUrlPostFix: "UBot/edit_belonging",
      MarkBotAsBlockedUrlPostFix: "mark_bot_as_blocked",
      BatchQuitChatroomUrlPostFix: "UChatroom/batch_quit_chatroom",
      addKeepAliveBotUrlPostFix: "add_keep_alive_bot",
      removeKeepAliveBotUrlPostFix: "remove_keep_alive_bot",
      modifyBotStatus: "ubot/modify_bot_status",
      getBotAbnormalLog: "UBot/get_bot_abnormal_log",
      modifyBotPwd: "ubot/modify_bot_pwd",
      getBotFriends: "ubot/get_friends",
      downloadBotFriends: "ubot/get_friends_excel",
      getBotStatis: "UDevice/export_devices_statis",
      bindClientModalData: null,
      bindChatroomModalData: null,
      pagination: {
        hideOnSinglePage: true,
        showTotal: (total) => `共 ${total} 个机器人`,
        pageSize: 10,
        current: 1,
      },
      filters: null,
      sorter: null,
      biz_list: [],
      provider_list: [],
      dataCurrent: [],
      data: [],
      dataTotal: [],
      available: null,
      loading: false,
      columns: [
        {
          title: "昵称",
          dataIndex: "base_info",
          scopedSlots: { customRender: "base_info" },
        },
        {
          title: "alias",
          dataIndex: "alias",
        },
        {
          title: "角色",
          dataIndex: "role",
          scopedSlots: { customRender: "role" },
          filters: [
            {
              text: "C 端",
              value: "0",
            },
            {
              text: "小 B",
              value: "1",
            },
            {
              text: "专属",
              value: "2",
            },
          ],
        },
        {
          title: "设备ID",
          dataIndex: "unique_id",
        },
        {
          title: "总进群上限",
          dataIndex: "enter_chatroom_count",
          scopedSlots: { customRender: "enter_chatroom_count" },
        },
        {
          title: "单日进群上限",
          dataIndex: "daily_enter_chatroom_count",
          scopedSlots: { customRender: "daily_enter_chatroom_count" },
        },
        {
          title: "今日进群",
          dataIndex: "chatroom_count_today",
          align: "center",
          scopedSlots: { customRender: "chatroom_count_today" },
          sorter: false,
        },
        {
          title: "总进群",
          dataIndex: "chatroom_count_total",
          align: "center",
          scopedSlots: { customRender: "chatroom_count_total" },
          sorter: false,
        },
        {
          title: "来源",
          dataIndex: "origin",
          scopedSlots: { customRender: "origin" },
        },
        {
          title: "客户",
          dataIndex: "biz_id",
          scopedSlots: { customRender: "biz_id" },
        },
        {
          title: "当前状态",
          dataIndex: "blocked",
          scopedSlots: { customRender: "blocked" },
          filters: [
            //   {
            //   text: '正在服务',
            //   value: '1'
            // },
            {
              text: "等待解封",
              value: "2",
            },
            {
              text: "彻底损失",
              value: "3",
            },
          ],
        },
        {
          title: "登录密码",
          dataIndex: "register_pwd",
          scopedSlots: { customRender: "register_pwd" },
        },
        {
          title: "支付密码",
          dataIndex: "pay_pwd",
          scopedSlots: { customRender: "pay_pwd" },
        },
        {
          title: "操作",
          dataIndex: "actions",
          scopedSlots: { customRender: "actions" },
        },
      ],
      showUnhealthBot: true,
      newBotVisible: false,
      bindClientVisible: false,
      bindClientConfirmLoading: false,
      bindChatroomVisible: false,
      bindChatroomConfirmLoading: false,
      withNumber: false,
      batchQuitChatroomFlag: false,
      batchQuitChatroomLoading: false,
      keepAliveLoading: false,
      underCheckingLoading: false,
      lose_reason: "",
      visible_lose: false,
      robot_status_value: 1,
      choosedRecord: "",
      visible_abnormal: false,
      visible_detail: false,
      detailData: {},
      confirmLoading_abnormal: false,
      handOffUrl: "",
      visible_hand_off: false,
      log_list: [],
      abnormalPage: {
        page: 1,
        pagesize: 20,
      },
      abnormal_type: 0,
      choosedLoginPwdEdit: "",
      choosedPayPwdEdit: "",
      register_pwd_text: "",
      pay_pwd_text: "",
      remark: "",
      visible_remark: false,
      visible_friends: false,
      botFriendsList: [],
      botShowFriendsList: [],
      friendListFilter: "",
      visible_block_input: false,
      visible_block_reason: false,
      visible_unblocked_record: false,
      block_phone_number: "",
      blocked_reason: "环境异常",
      unblocked_phone: "",
      blocked_reason_loading: false,
      unblocked_record_loading: false,
      blocked_reason_list: [],
      unblocked_record_list: [],
      c_device: null,
      searchNickname: "",
      searchUsername: "",
      searchAlias: "",

      chosedBot: {},
      chosedBotDaily: {},
      enter_chatroom_count: undefined,
      daily_enter_chatroom_count: undefined,
    };
  },
  computed: {
    params: function () {
      // console.log('filter', this.filters)
      return {
        // results: this.pagination.pageSize,
        page: this.pagination.current,
        page_size: this.pagination.pageSize,
        // chatroom_nickname: this.searchChatroomNickname,
        // owner_nickname: this.searchOwnerNickname,
        // level: (this.filters.level || []).map(item => parseInt(item)),
        // group: (this.filters.group || []).map(item => parseInt(item)),
        // order_by: this.order_by
      };
    },
    getBotListUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.getBotListUrlPostFix;
    },
    bindClientUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.bindClientUrlPostFix;
    },
    newBlockedReasonUrl: function () {
      return (
        global.DOMAIN + global.API_VERSION + this.newBlockedReasonUrlPostFix
      );
    },
    newUnblockedRecordUrl: function () {
      return (
        global.DOMAIN + global.API_VERSION + this.newUnblockedRecordUrlPostFix
      );
    },
    getBlockedReasonListUrl: function () {
      return (
        global.DOMAIN + global.API_VERSION + this.getBlockedReasonListUrlPostFix
      );
    },
    getUnblockedRecordListUrl: function () {
      return (
        global.DOMAIN +
        global.API_VERSION +
        this.getUnblockedRecordListUrlPostFix
      );
    },
    batchBindChatroomUrl: function () {
      return (
        global.DOMAIN + global.API_VERSION + this.batchBindChatroomUrlPostFix
      );
    },
    EditBotTypeUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.EditBotTypeUrlPostFix;
    },
    EditBelongingUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.EditBelongingUrlPostFix;
    },
    MarkBotAsBlockedUrl: function () {
      return (
        global.DOMAIN + global.API_VERSION + this.MarkBotAsBlockedUrlPostFix
      );
    },
    BatchQuitChatroomUrl: function () {
      return (
        global.DOMAIN + global.API_VERSION + this.BatchQuitChatroomUrlPostFix
      );
    },
    addKeepAliveBotUrlUrl: function () {
      return global.location + "api/" + this.addKeepAliveBotUrlPostFix;
    },
    removeKeepAliveBotUrl: function () {
      return global.location + "api/" + this.removeKeepAliveBotUrlPostFix;
    },
    modifyBotStatusUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.modifyBotStatus;
    },
    getBotAbnormalLogUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.getBotAbnormalLog;
    },
    modifyBotPwdUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.modifyBotPwd;
    },
    getBotFriendsUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.getBotFriends;
    },
    downloadFriendsListUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.downloadBotFriends;
    },
    getBotStatisUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.getBotStatis;
    },
    getBizListUrl: function () {
      return global.DOMAIN + global.API_VERSION + "ubiz/get_biz_list";
    },
    bindBizUrl: function () {
      return global.DOMAIN + global.API_VERSION + "ubot/bind_biz";
    },
    getProviderListUrl: function () {
      return global.DOMAIN + global.API_VERSION + "uprovider/get_provider_list";
    },
    bindProviderUrl: function () {
      return global.DOMAIN + global.API_VERSION + "ubot/bind_provider";
    },
    getDeviceUrl: function () {
      return global.DOMAIN + global.API_VERSION + "udevice/get_device";
    },
    underCheckingUrl: function () {
      return global.DOMAIN + global.API_VERSION + "ubot/set_bot_under_checking";
    },
    getHandOffUrl: function () {
      return global.DOMAIN + global.API_VERSION + "ubot/hand_off";
    },
  },
  created() {
    this.fetch();
    this.fetchBizList();
    this.getProviderList();
  },
  methods: {
    fetchBizList() {
      axios
        .post(this.getBizListUrl, {
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            this.biz_list = data.data.content.biz_list;
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    getProviderList() {
      axios
        .post(this.getProviderListUrl, {
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            this.provider_list = data.data.content.provider_list;
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    bindProvider(e, record, type) {
      if (e === record[type]) {
        return;
      }
      axios
        .post(this.bindProviderUrl, {
          u_provider_id: e,
          provider_type: type,
          bot_username: record.username,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            record[type] = e;
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    bindBiz(e, record) {
      if (e === record.u_biz_id) {
        return;
      }
      axios
        .post(this.bindBizUrl, {
          u_biz_id: e,
          bot_username: record.username,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            record.u_biz_id = e;
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;

      this.filters = filters;
      this.sorter = sorter;

      this.search(false)
    },
    fetch(countFlag = 1) {
      this.searchUsername = "";
      this.searchNickname = "";
      this.searchAlias = "";

      this.loading = true;
      axios
        .post(this.getBotListUrl, {
          count_flag: countFlag,
          token: sessionStorage.token,
          ...this.params,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            if (countFlag === 1) {
              this.withNumber = true;
              this.available = 0;
              this.columns[4].sorter = true;
              this.columns[5].sorter = true;
            }
            const pagination = { ...this.pagination };
            pagination.total = data.data.content.total_count;
            let botList = data.data.content.bot_list;
            let dataList = [];
            botList.forEach((item) => {
              // console.log(item.pay_pwd)
              let baseInfo = {
                avatar_url: item.avatar_url,
                nickname: item.nickname || "",
                username: item.username,
              };
              let deviceId = item.device_id || "-";
              let uniqueId = item.unique_id || "-";
              let isAlive = item.is_alive || false;
              let remark = item.remark || "-";
              let createTime = item.create_bot_time;
              let isVip = item.vip ? "是" : "否";
              let origin = item.belonging || "采购";
              let chatroomCountToday = "-";
              let chatroomCountTotal = "-";
              let blocked = 1;
              let register_pwd = item.register_pwd || "---";
              let pay_pwd = item.register_pwd || "---";
              let alias = item.alias || "---";
              if (item.block_status == 3) {
                blocked = 3;
              } else if (item.block_status == 2) {
                blocked = 2;
              }
              let destroyed_remark = item.destroyed_remark;
              if (item.chatroom_count) {
                chatroomCountToday = item.chatroom_count.today | 0;
                chatroomCountTotal = item.chatroom_count.total | 0;
              }

              let role = "3";
              if (item.vip === 1 && item.doodod === 1) {
                // 小 B
                role = "1";
              } else if (item.vip === 1 && item.doodod === 0) {
                // 专属
                role = "2";
              } else if (item.vip === 0 && item.doodod === 1) {
                // C 端
                role = "0";
              }

              if (role === "0" && item.blocked !== 1 && item.is_alive) {
                this.available +=
                  chatroomCountTotal < 100 ? 100 - chatroomCountTotal : 0;
              }

              dataList.push({
                base_info: baseInfo,
                chatroom_count_today: chatroomCountToday,
                chatroom_count_total: chatroomCountTotal,
                device_id: deviceId,
                unique_id: uniqueId,
                role: role,
                is_alive: isAlive,
                remark: remark,
                is_vip: isVip,
                origin: origin,
                blocked: blocked,
                destroyed_remark: destroyed_remark,
                register_pwd: register_pwd,
                pay_pwd: pay_pwd,
                alias: alias,
                biz_id: item.u_biz_id,
                ...item,
                create_time: this.transform(createTime, "yyyy-MM-dd hh:mm:ss"),
              });
            });
            this.loading = false;
            // console.log('dataList', dataList)
            this.data = dataList;
            this.dataTotal = dataList;
            pagination.total = this.data.length;
            this.pagination = pagination;
            this.dataCurrent = this.data.slice(
              (this.pagination.current - 1) * this.pagination.pageSize,
              this.pagination.current * this.pagination.pageSize
            );
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    transform(value, fmt, ...args) {
      if (typeof value === "number") {
        // 如果是 秒 为单位就变为毫秒
        if (String(value).length === 10 || String(value).length === 11)
          value *= 1000;

        let date = new Date(value);
        var o = {
          "M+": date.getMonth() + 1, // 月份
          "d+": date.getDate(), // 日
          "h+": date.getHours(), // 小时
          "m+": date.getMinutes(), // 分
          "s+": date.getSeconds(), // 秒
          "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
          S: date.getMilliseconds(), // 毫秒
          W: date.getDay(),
        };
        var weekMap = [
          "星期日",
          "星期一",
          "星期二",
          "星期三",
          "星期四",
          "星期五",
          "星期六",
        ];
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        }
        for (var k in o) {
          if (new RegExp("(" + k + ")").test(fmt) && k !== "W") {
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length === 1
                ? o[k]
                : ("00" + o[k]).substr(("" + o[k]).length)
            );
          }
          if (new RegExp("(" + k + ")").test(fmt) && k === "W") {
            fmt = fmt.replace(RegExp.$1, weekMap[o[k]]);
          }
        }
        return fmt;
      } else return "";
    },
    handleMenuClick(e, record) {
      let action = e.key;
      if (action === "detail") {
        this.detailData = record;
        this.visible_detail = true;
        if (record.unique_id) {
          this.fetchDevice(record.unique_id);
        }
      }
      if (action === "bind_client") {
        this.bindClient(record);
      }
      if (action === "bind_chatroom") {
        this.bindChatroom(record);
      }
      if (action === "mark_as_blocked") {
        this.markAsBlocked(1, record);
      }
      if (action === "mark_as_unblocked") {
        this.markAsBlocked(0, record);
      }
      if (action === "batch_quit_chatroom") {
        this.batchQuitChatroomFlag = !this.batchQuitChatroomFlag;
      }
      if (action === "batch_quit_chatroom_confirm") {
        this.batchQuitChatroomFlag = !this.batchQuitChatroomFlag;
        this.batchQuitChatroom(record);
      }
      if (action === "add_keep_alive_bot") {
        record.keepAlive = !record.keepAlive;
        this.addKeepAliveBot(record);
      }
      if (action === "remove_keep_alive_bot") {
        record.keepAlive = !record.keepAlive;
        this.removeKeepAliveBot(record);
      }
      if (action === "destroy_reason") {
        this.visible_lose = true;
        this.showLoseMessage(record);
      }
      if (action === "bot_abnormal_log") {
        this.visible_abnormal = true;
        this.choosedRobot(record);
      }
      if (action === "remark") {
        this.visible_remark = true;
        this.choosedRobotRemark(record);
      }
      if (action === "bot_friends") {
        this.visible_friends = true;
        this.getFriendsList(record);
      }
      if (action === "get_bot_friends") {
        this.downloadFriendsList(record);
      }
      if (action === "groupSending") {
        this.$router.push({
          name: "GroupSending",
          params: {
            username: record.username,
            nickname: record.nickname,
          },
        });
      }
      if (action === "block_phone") {
        this.visible_block_input = true;
        this.ChoosedRobotBlockPhone(record);
      }
      if (action === "blocked_reason") {
        this.fetchBlockedReasonList(record);
        this.detailData = record;
        this.visible_block_reason = true;
      }
      if (action === "unblocked_record") {
        this.fetchUnblockedRecordList(record);
        this.detailData = record;
        this.visible_unblocked_record = true;
      }
      if (action === "under_checking") {
        this.underCheckingBot(record, 1);
      }
      if (action === "stop_under_checking") {
        this.underCheckingBot(record, 0);
      }
      if (action === "hand_off") {
        this.detailData = record;
        this.visible_hand_off = true;
      }
    },

    underCheckingBot(record, under_checking) {
      this.underCheckingLoading = true;
      axios
        .post(this.underCheckingUrl, {
          bot_username: record.username,
          under_checking: under_checking,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            record.under_checking = under_checking;
            this.underCheckingLoading = false;
            window.alert("监控成功");
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    handOffOK() {
      axios
        .post(this.getHandOffUrl, {
          bot_username: this.detailData.username,
          hand_url: this.handOffUrl,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            alert("登录成功");
          } else {
            alert("登录失败");
          }
        });
    },
    fetchDevice(unique_id) {
      axios
        .post(this.getDeviceUrl, {
          unique_id: unique_id,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            this.c_device = data.data.content.device;
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    fetchBlockedReasonList(record) {
      //
      this.blocked_reason_loading = true;
      axios
        .post(this.getBlockedReasonListUrl, {
          bot_username: record.username,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            this.blocked_reason_list = data.data.content.blocked_reason_list;
            this.blocked_reason_loading = false;
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    newBlockReason(record, blocked_reason) {
      axios
        .post(this.newBlockedReasonUrl, {
          blocked_reason: blocked_reason,
          bot_username: record.username,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            this.blocked_reason_list.push(data.data.content.blocked_reason);
            this.blocked_reason = "环境异常";
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    fetchUnblockedRecordList(record) {
      //
      this.unblocked_record_loading = true;
      axios
        .post(this.getUnblockedRecordListUrl, {
          bot_username: record.username,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            this.unblocked_record_list =
              data.data.content.unblocked_record_list;
            this.unblocked_record_loading = false;
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    newUnblockRecord(record, unblocked_phone) {
      axios
        .post(this.newUnblockedRecordUrl, {
          unblocked_phone: unblocked_phone,
          bot_username: record.username,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            this.unblocked_record_list.push(data.data.content.unblocked_record);
            this.unblocked_phone = "";
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    bindClient(record) {
      // console.log('bindClient')
      this.bindClientVisible = true;
      this.bindClientModalData = record;
    },
    bindClientFinish(botUsername, phone, app, vip) {
      // console.log('bindClientFinish', botUsername, phone, app, vip)
      this.bindClientConfirmLoading = true;
      axios
        .post(this.bindClientUrl, {
          bot_username: botUsername,
          phone: phone,
          app: app,
          vip: parseInt(vip),
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            // console.log('绑定成功')
            this.bindClientVisible = false;
            // this.bindClientModalData = null
            this.bindClientConfirmLoading = false;
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    bindClientCancel() {
      // console.log('bindClientCancel')
      this.bindClientVisible = false;
      // this.bindClientModalData = null
      this.bindClientConfirmLoading = false;
    },
    bindChatroom(record) {
      // console.log('bindClient')
      this.bindChatroomVisible = true;
      this.bindChatroomModalData = record;
    },
    bindChatroomFinish(botUsername, clientId, chatroomnameSelected) {
      // console.log('bindClientFinish', botUsername, phone, app, vip)
      this.bindChatroomConfirmLoading = true;
      axios
        .post(this.batchBindChatroomUrl, {
          bot_username: botUsername,
          chatroomname_list: chatroomnameSelected,
          client_id: parseInt(clientId),
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            // console.log('绑定成功')
            this.bindChatroomVisible = false;
            // this.bindChatroomModalData = null
            this.bindChatroomConfirmLoading = false;
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    bindChatroomCancel() {
      // console.log('bindClientCancel')
      this.bindChatroomVisible = false;
      this.bindChatroomConfirmLoading = false;
      // this.bindChatroomModalData = null
    },
    newBot() {
      this.newBotVisible = true;
    },
    newBotFinish() {
      this.newBotVisible = false;
      // this.fetch()
    },
    newBotCancel() {
      this.newBotVisible = false;
    },
    onRoleSelected(e, record) {
      if (e !== record.role) {
        let vip = 1;
        let doodod = 1;
        if (e === "0") {
          vip = 0;
          doodod = 1;
        } else if (e === "1") {
          vip = 1;
          doodod = 1;
        } else if (e === "2") {
          vip = 1;
          doodod = 0;
        } else {
          return;
        }
        axios
          .post(this.EditBotTypeUrl, {
            bot_username: record.username,
            doodod: doodod,
            vip: vip,
            token: sessionStorage.token,
          })
          .then((data) => {
            if (data.data.err_code === 0) {
              // console.log('绑定成功')
              record.doodod = doodod;
              record.vip = vip;
              record.role = e;
              // 重新计算当前可用群数
              if (this.available !== null) {
                this.available = 0;
                this.dataTotal.forEach((item) => {
                  if (
                    item.role === "0" &&
                    item.blocked !== 1 &&
                    item.is_alive
                  ) {
                    this.available +=
                      item.chatroom_count_total < 100
                        ? 100 - item.chatroom_count_total
                        : 0;
                  }
                });
              }
              window.alert("更新机器人角色成功");
            } else if (data.data.err_code === 50002) {
              console.log("token 不对，跳转登录");
              this.$router.push("/");
            }
          });
      }
    },
    onBelongingSelected(e, record) {
      if (e !== record.origin) {
        axios
          .post(this.EditBelongingUrl, {
            bot_username: record.username,
            belonging: e,
            token: sessionStorage.token,
          })
          .then((data) => {
            if (data.data.err_code === 0) {
              // console.log('绑定成功')
              record.origin = e;
              // window.alert('更新机器人来源成功')
            } else if (data.data.err_code === 50002) {
              console.log("token 不对，跳转登录");
              this.$router.push("/");
            }
          });
      }
    },
    markAsBlocked(blocked, record) {
      axios
        .post(this.MarkBotAsBlockedUrl, {
          blocked: blocked,
          bot_username: record.username,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            // console.log('绑定成功')
            record.blocked = blocked;
            // 重新计算当前可用群数，懒
            if (this.available !== null) {
              this.available = 0;
              this.dataTotal.forEach((item) => {
                if (item.role === "0" && item.blocked !== 1 && item.is_alive) {
                  this.available +=
                    item.chatroom_count_total < 100
                      ? 100 - item.chatroom_count_total
                      : 0;
                }
              });
            }
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    batchQuitChatroom(record) {
      this.batchQuitChatroomLoading = true;
      axios
        .post(this.BatchQuitChatroomUrl, {
          bot_username: record.username,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            // console.log('绑定成功')
            window.alert("正在退群");
            this.batchQuitChatroomLoading = false;
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    addKeepAliveBot(record) {
      this.keepAliveLoading = true;
      axios
        .post(this.addKeepAliveBotUrlUrl, {
          bot_username: record.username,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            // console.log('绑定成功')
            window.alert("开始养号");
            this.keepAliveLoading = false;
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    removeKeepAliveBot(record) {
      this.keepAliveLoading = true;
      axios
        .post(this.removeKeepAliveBotUrl, {
          bot_username: record.username,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            // console.log('绑定成功')
            window.alert("停止养号");
            this.keepAliveLoading = false;
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    handleLoseOk() {
      let params = {
        bot_username: this.choosedRecord.username,

        token: sessionStorage.token,
      };
      if (this.lose_reason) {
        params.destroyed_remark = this.lose_reason;
      }
      if (this.robot_status_value) {
        params.block_status = this.robot_status_value;
      }
      if (this.block_phone_number) {
        params.phone = this.block_phone_number;
      }
      axios.post(this.modifyBotStatusUrl, params).then((data) => {
        if (data.data.err_code === 0) {
          this.visible_lose = false;
          this.choosedRecord.phone = this.block_phone_number;
          this.block_phone_number = "";
        } else {
          console.log("出错了");
        }
      });
    },

    handleLoseCancel() {
      this.visible_lose = false;
    },
    showLoseMessage(record) {
      this.choosedRecord = record;
      this.robot_status_value = record.block_status;
      this.lose_reason = record.destroyed_remark;
      // axios.post(this.modifyBotStatusUrl, {
      //   bot_username: record.username,
      //   token: sessionStorage.token
      // })
      //   .then((data) => {
      //     if (data.data.err_code === 0) {
      //       this.lose_reason = data.data.username;
      //       this.robot_status_value = data.data.robot_status_value;
      //     } else {
      //       console.log('出错了')
      //     }
      //   })
    },
    choosedRobot(record) {
      this.choosedRecord = record;
      this.showAbnormalLog();
    },
    showAbnormalLog() {
      let params = {
        bot_username: this.choosedRecord.username,
        page: this.abnormalPage.page,
        pagesize: this.abnormalPage.pagesize,
        token: sessionStorage.token,
      };
      if (this.abnormal_type != 0) {
        params.type = this.abnormal_type;
      }
      axios.post(this.getBotAbnormalLogUrl, params).then((data) => {
        if (data.data.err_code == 0) {
          this.log_list = data.data.content.log_list;
        } else {
          console.log("出错了");
        }
      });
    },
    checkLoginPwd(e) {
      axios
        .post(this.modifyBotPwdUrl, {
          bot_username: e.username,
          register_pwd: this.register_pwd_text,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code == 0) {
            this.choosedLoginPwdEdit = undefined;
            e.register_pwd = data.data.content.register_pwd;
            this.register_pwd_text = "";
          } else {
            console.log("出错了");
          }
        });
    },
    editLoginPwd(e) {
      this.choosedLoginPwdEdit = e.a_contact_id;
      this.register_pwd_text = e.register_pwd;
    },
    checkPayPwd(e) {
      axios
        .post(this.modifyBotPwdUrl, {
          bot_username: e.username,
          pay_pwd: this.pay_pwd_text,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code == 0) {
            this.choosedPayPwdEdit = undefined;
          } else {
            console.log("出错了");
          }
        });
    },
    editPayPwd(e) {
      this.choosedPayPwdEdit = e.a_contact_id;
      this.pay_pwd_text = e.pay_pwd;
    },
    // handleChange(e){
    //   this.login_pwd_text = e;
    // }
    handleDetailOK() {
      this.visible_detail = false;
    },
    handleLogOK() {
      this.visible_abnormal = false;
    },
    choosedRobotRemark(record) {
      this.choosedRecord = record;
      this.remark = record.remark || "";
    },
    handleRemarkOK() {
      axios
        .post(this.modifyBotStatusUrl, {
          bot_username: this.choosedRecord.username,
          remark: this.remark,
          token: sessionStorage.token,
        })
        .then(() => {
          this.visible_remark = false;
          this.choosedRecord.remark = this.remark;
          this.remark = "";
        });
    },
    handleRemarkCancle() {
      this.visible_remark = false;
    },
    getFriendsList(record) {
      axios
        .post(this.getBotFriendsUrl, {
          bot_username: record.username,
          token: sessionStorage.token,
        })
        .then((res) => {
          this.botFriendsList = res.data.content.friend_nickname_list;
          this.botShowFriendsList = JSON.parse(
            JSON.stringify(this.botFriendsList)
          );
        });
    },
    downloadFriendsList(record) {
      let outputUrl = this.downloadFriendsListUrl + "?";
      outputUrl += "bot_username" + "=" + record.username + "&";
      outputUrl += "token" + "=" + sessionStorage.token;
      window.open(outputUrl, "_blank");
    },
    handleFriendsCancle() {
      this.visible_friends = false;
    },
    getFilterList() {
      this.botShowFriendsList = JSON.parse(JSON.stringify(this.botFriendsList));
      this.botShowFriendsList = this.botFriendsList.filter((item) => {
        return item.nickname.indexOf(this.friendListFilter) > -1;
      });
      if (!this.friendListFilter || this.friendListFilter.length == 0) {
        this.botShowFriendsList = JSON.parse(
          JSON.stringify(this.botFriendsList)
        );
      }
    },
    botStatisList() {
      axios
        .post(this.getBotStatisUrl, {
          token: sessionStorage.token,
        })
        .then((res) => {
          window.location.href = res.data.content.path;
        });
    },
    showUnhealthBotFunc(value) {
      this.showUnhealthBot = value;
      if (!this.showUnhealthBot) {
        this.data = this.dataTotal.filter((d) => {
          return d.is_alive === true && d.blocked === 1;
        });
        if (this.filters && this.filters.blocked) {
          this.filters.blocked.splice(0, this.filters.blocked.length);
        }
      } else {
        this.data = this.dataTotal;
      }
      this.pagination.total = this.data.length;
      this.dataCurrent = this.data.slice(
        (this.pagination.current - 1) * this.pagination.pageSize,
        this.pagination.current * this.pagination.pageSize
      );
    },
    search(resetCurPage=true) {
      this.data = this.dataTotal;

      if (resetCurPage) {
        this.pagination.current = 1;
      }
      if (this.filter) {
        let blockedList = (this.filters.blocked || []).map((item) => parseInt(item));
        if (blockedList && blockedList.length) {
          this.showUnhealthBot = true;
          this.data = this.data.filter((item) => {
            return blockedList.find((it) => it === item.blocked) !== undefined;
          });
        }

        let roleFilter = this.filters.role;
        if (roleFilter && roleFilter.length) {
          let vipFilter = [];
          let doododFilter = [];
          for (let i = 0; i < roleFilter.length; i++) {
            let role = roleFilter[i];
            if (role === "0") {
              vipFilter.push(0);
              doododFilter.push(1);
            } else if (role === "1") {
              vipFilter.push(1);
              doododFilter.push(1);
            } else {
              vipFilter.push(1);
              doododFilter.push(0);
            }
          }

          this.dataPart = [];
          this.data.forEach((item) => {
            for (let i = 0; i < roleFilter.length; i++) {
              if (item.vip === vipFilter[i] && item.doodod === doododFilter[i]) {
                this.dataPart.push(item);
                break;
              }
            }
          });
          this.data = this.dataPart;
        }
      }
      if (this.sorter) {
        const { columnKey, order } = this.sorter;
        if (order === "ascend") {
          this.data.sort(function (a, b) {
            return a[columnKey] - b[columnKey];
          });
        } else if (order === "descend") {
          this.data.sort(function (a, b) {
            return b[columnKey] - a[columnKey];
          });
        }
      }
      if (this.searchNickname || this.searchUsername || this.searchAlias) {
        this.data = this.data.filter((item) => {
          return (
            (this.searchNickname &&
              item.nickname &&
              item.nickname.indexOf(this.searchNickname) !== -1) ||
            (this.searchUsername && item.username === this.searchUsername) ||
            (this.searchAlias && item.alias === this.searchAlias)
          );
        });
      } else {
        this.data = this.data;
      }
      this.pagination.total = this.data.length;
      this.dataCurrent = this.data.slice(
        (this.pagination.current - 1) * this.pagination.pageSize,
        this.pagination.current * this.pagination.pageSize
      );
    },
    clear() {
      this.searchUsername = "";
      this.searchNickname = "";
      this.searchAlias = "";
      this.data = this.dataTotal
      this.search()
    },

    checkChatroomCount(record, type) {
      if (type == "all") {
        axios
          .post(
            global.DOMAIN + global.API_VERSION + "ubot/edit_bot_chatroom_count",
            {
              enter_chatroom_count: +this.enter_chatroom_count,
              bot_username: record.username,
              token: sessionStorage.token,
            }
          )
          .then((res) => {
            record.enter_chatroom_count = this.enter_chatroom_count;
            this.enter_chatroom_count = undefined;
            this.chosedBot = null;
          });
      } else {
        axios
          .post(
            global.DOMAIN +
              global.API_VERSION +
              "ubot/edit_bot_daily_chatroom_count",
            {
              daily_enter_chatroom_count: +this.daily_enter_chatroom_count,
              bot_username: record.username,
              token: sessionStorage.token,
            }
          )
          .then((res) => {
            record.daily_enter_chatroom_count = this.daily_enter_chatroom_count;
            this.daily_enter_chatroom_count = undefined;
            this.chosedBotDaily = null;
          });
      }
    },

    editChatroomCount(record, type) {
      if (type == "all") {
        this.chosedBot = record;
        this.enter_chatroom_count = record.enter_chatroom_count;
      } else {
        this.chosedBotDaily = record;
        this.daily_enter_chatroom_count = record.daily_enter_chatroom_count;
      }
    },
  },
};
</script>

<style scoped>
</style>
